import { render, staticRenderFns } from "./companiesCollected.vue?vue&type=template&id=57db3fa6&scoped=true&"
import script from "./companiesCollected.vue?vue&type=script&lang=js&"
export * from "./companiesCollected.vue?vue&type=script&lang=js&"
import style0 from "./companiesCollected.vue?vue&type=style&index=0&id=57db3fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db3fa6",
  null
  
)

export default component.exports